<template>
	<div class="scroll-to-top" v-show="showButton" @click="doScroll()">
		<fa-icon v-if="featureSet.scrollToTop.arrow" icon="arrow-up"/>
		<fa-icon v-else icon="angle-double-up" />
	</div>
</template>

<script>
import featureSetLoaderMixin from '@/store/modules/featureSet/feature-set-loader';

export default {
	name: 'ScrollToTop',
	mixins: [featureSetLoaderMixin],
	data() {
		return {
			targetClass: 'content-container',
		};
	},
	props: {
		target: [String],
		showButton: [Boolean],
	},
	created() {
		if (this.target && this.target.length && this.target.length > 1) {
			this.targetClass = this.target;
		}
	},
	methods: {
		doScroll() {
			const options = {
				top: 0,
				left: 0,
				behavior: 'smooth',
			};
			try {
				document.getElementsByClassName(this.targetClass)[0].scrollTo(options);
			} finally {
				window.scrollTo(options);
			}
		},
	},
};
</script>

<style src="@/styles/components/ScrollToTop/ScrollToTop.less" lang="less" scoped></style>
